<template>
  <div>
    <b-modal
      id="modal-sert2"
      ref="modal-sert2"
      centered
      hide-footer
      hide-header
      title-sr-only:false
    >
     <b-row >
        <b-button @click="hideModal" class="close ml-auto mr-3 mb-3"  >
                         <b-icon icon="plus" class="closeplus"></b-icon>
                      </b-button>
      </b-row>
       <img src="../img/sert2.jpg"  style="width:100%" alt="">
     </b-modal>
  </div>
</template>
<script>
export default {
    methods: {
    hideModal() {
      this.$refs["modal-sert2"].hide();
    },
  },
}
</script>